export default __webpack_public_path__ + "static/media/Cynosural Ale.2cff40a2.jpg";